module.exports = __webpack_public_path__ + "img/tzgg.0eba247d.png";